import { createApp } from 'vue';
import App from './App.vue';
import router from '@/router/index.js';
import store from '@/store/index.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import JsonExcel from "vue-json-excel3";

// FontAwesome импорты
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faLock, faBars, faTimes, faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// PrimeVue импорты
import PrimeVue from 'primevue/config';

// PrimeVue компоненты
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import Tooltip from 'primevue/tooltip';
import ToggleSwitch from 'primevue/togglebutton';

// Подключение стилей
import 'primevue/resources/themes/lara-light-blue/theme.css';  // тема
import 'primevue/resources/primevue.css';            // основные стили
import 'primeicons/primeicons.css';                      // иконки
import 'primeflex/primeflex.css';                        // утилиты для сетки

// Добавляем иконки в библиотеку FontAwesome
library.add(faUser, faLock, faBars, faTimes, faChevronRight, faChevronDown);

const app = createApp(App);

// Регистрируем глобальные компоненты
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('json-excel', JsonExcel);
app.component('p-input-number', InputNumber);
app.component('p-dropdown', Dropdown);
app.component('p-checkbox', Checkbox);
app.component('p-button', Button);
app.component('p-toggle-switch', ToggleSwitch);

// Подключаем PrimeVue
app.use(PrimeVue, {
    ripple: true,
    inputStyle: "filled"
});

// Подключаем роутер и стор
app.use(router);
app.use(store);
app.directive('tooltip', Tooltip);
app.mount('#app');
